import apiRequest from './handler';

const CallbacksService = {
    /**
     * Fetches callbacks with pagination, sorting, and filtering
     * @param {Object} params - Query parameters including pagination, sorting, and filters
     * @param {function} setIsAuthenticated - Function to update authentication state
     * @param {function} navigate - Function to navigate to a different route
     * @returns {Promise} - A promise that resolves to the server's response
     */
    getCallbacks: async (params, setIsAuthenticated, navigate) => {
        try {
            const queryParams = new URLSearchParams(params);
            const response = await apiRequest(
                `/support/callbacks?${queryParams.toString()}`,
                'GET',
                null,
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching callbacks:', error);
            throw error;
        }
    },

    /**
     * Updates the status and notes of a callback request
     * @param {number|string} callbackId - The ID of the callback to update
     * @param {Object} updateData - Object containing status and notes
     * @param {function} setIsAuthenticated - Function to update authentication state
     * @param {function} navigate - Function to navigate to a different route
     * @returns {Promise} - A promise that resolves to the server's response
     */
    updateCallbackStatus: async (callbackId, updateData, setIsAuthenticated, navigate) => {
        try {
            const response = await apiRequest(
                `/support/callbacks/${callbackId}/status`,
                'POST',
                updateData,
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error updating callback status:', error);
            throw error;
        }
    }
};

export default CallbacksService;